/**
 * escala-cifra.js — Tamaño de la CIFRA de una estadística según lo que mide.
 *
 * Módulo PURO (sin DOM ni `window`), ES2019: lo importa `blocks/stats.js` y se prueba en node
 * (tests/_escala_cifra.mjs).
 *
 * Caso real (22-09-2026): una stat con «Interior y Exterior» donde va la cifra se pintaba a
 * 5,5 rem, como «+15», y con `overflow-wrap: break-word` partía las palabras por la mitad
 * («Interio / r y / Exteri / or»). La cifra de una estadística cabe en ~6 caracteres («+150%»,
 * «24/7», «1.200+»); a partir de ahí se encoge en proporción a lo que mide, de modo que las
 * palabras vuelvan a caber enteras en su columna. Mismo principio que `--title-len` en los
 * titulares: el tamaño lo decide lo que MIDE el texto, no un tope fijo.
 */

/** Caracteres visibles que caben al tamaño pleno. */
const CARACTERES_PLENOS = 6;
/** Nunca por debajo de esta fracción del tamaño pleno (un texto muy largo ya parte en espacios). */
const ESCALA_MINIMA = 0.3;

/** Caracteres VISIBLES de la cifra: sin etiquetas (el inline puede traer `<span>` de color) y con
 *  cada entidad contada como uno. Cuenta caracteres, no unidades UTF-16 (un emoji es uno). */
function caracteresVisibles(texto) {
    const plano = String(texto == null ? '' : texto)
        .replace(/<[^<>]*>/g, '')
        .replace(/&(?:#\d+|#x[0-9a-f]+|[a-z][a-z0-9]*);/gi, 'x')
        .replace(/\s+/g, ' ')
        .trim();
    return Array.from(plano).length;
}

/** Factor (0,3-1) por el que multiplicar el tamaño de la cifra. 1 = tamaño pleno. */
export function escalaCifra(texto) {
    const n = caracteresVisibles(texto);
    if (n <= CARACTERES_PLENOS) return 1;
    return Math.max(ESCALA_MINIMA, Math.round((CARACTERES_PLENOS / n) * 1000) / 1000);
}

/** `font-size` de la cifra: el `tamano` CSS de la variante tal cual, o escalado si la cifra es
 *  larga. Con una cifra normal devuelve EXACTAMENTE `tamano` (el HTML no cambia). */
export function tamanoCifra(tamano, texto) {
    const f = escalaCifra(texto);
    return f === 1 ? tamano : 'calc(' + tamano + ' * ' + f + ')';
}
